<template>
  <div
    style="min-height: 48px"
    :class="selected && 'oderon lighten-1'"
    class="d-flex flex-column clickable hoverable px-4 justify-center"
  >
    <div class="d-flex flex-row-nowrap">
      <div class="grow-1 shrink-1 font-weight-bold">{{ variable.code }}</div>
      <div class="w-4 mono text-right">{{ variable.pgn }}</div>
      <div class="w-2 mono text-right">{{ variable.spnStart }}</div>
      <div class="w-2 mono text-right">{{ variable.spnLen }}</div>
      <div class="w-3 mono text-right">{{ variable.multiplier }}</div>
      <div class="w-3 mono text-right">{{ variable.divisor }}</div>
      <div class="w-2 mono text-right">{{ variable.opts }}</div>
    </div>
    <div v-if="strComments != null">{{ strComments }}</div>
  </div>
</template>

<script>
export default {
  props: {
    variable: {},
    selected: {}
  },
  computed: {
    strComments() {
      if (this.variable.added)
        return '(Variável atual, mas não existe no dicionário)'
      // if (this.variable.code == 'speed') return 'comentário curto sobre speed'
      // if (this.variable.code == 'brake')
      //   return 'história completa de como João Ventura conseguiu descobrir o spn do pgn do brake do can do veículo do módulo'
      return this.variable.comments
    }
  }
}
</script>

<style></style>
